import { BrowserRouter } from "react-router-dom";

//routes
import AllRoutes from ".";

const Routes = () => {
  const basename = window.location.pathname.replace(/\/$/, "");

  return (
    <BrowserRouter basename={basename}>
      <AllRoutes />
    </BrowserRouter>
  );
};

export default Routes;
